import $ from 'jquery';

$(function () {
    if ($('#leadership_page').length) {
        renderCustomSelect();

        $(window).on('resize', function () {
            renderCustomSelect();
        });

        var $managerProfile = $('.manager-profile');
        var $cmgProfile = $('.cmg-profile');

        $managerProfile.on('click', '.close-btn', function (e) {
            $managerProfile.removeClass('show');
            $cmgProfile.removeClass('blured');
        });
    }

    function renderCustomSelect() {
        if (window.screen.width  < 768) {
            return;
        }

        var $customSelect = $('.team-selector');
        if ($customSelect.find('div').length > 0)
            return;

        var $selectedItem = $(`<div class="selected-item"><span class="selected-text"></span><span class="arrow"><i class="fas fa-angle-down"></i></span></div>`);
        $selectedItem.appendTo($customSelect);

        var $optionContainer = $('<div class="select-items select-hide"></div>');
        $customSelect.find('select option').each(function (index, elem) {
            var $item = $(`<div class=${index === 0 ? "same-as-selected" : ""}>${elem.innerHTML}</div>`);
            $item.on('click', function (e) {
                $optionContainer.find('.same-as-selected').removeClass('same-as-selected');
                $(this).addClass('same-as-selected');
                $selectedItem.find('.selected-text').text(elem.innerHTML);

                $('.team-container').removeClass('show');
                $(`#${elem.value}`).addClass('show');

                closeSelect(e);
            });
            $item.appendTo($optionContainer);

            if (index === 0) {
                $selectedItem.find('.selected-text').text(elem.innerHTML);
                $(`#${elem.value}`).addClass('show');
            }
        });
        $optionContainer.appendTo($customSelect);

        $customSelect.find('.selected-item').on('click', function (e) {
            closeSelect(e);
        });

        $('body').on('click', function (e) {
            if ($selectedItem.hasClass("select-arrow-active")) {
                closeSelect(e);
            }
        });

        function closeSelect(event) {
            event.stopPropagation();
            $optionContainer.toggleClass("select-hide");
            $selectedItem.toggleClass("select-arrow-active");
        }
    }
});